var map = {
	"./view_bigquery_workbench.pug": 3707,
	"./view_hubspot_workbench.pug": 6463,
	"./view_salesforce_workbench.pug": 9873,
	"./view_segment_workbench.pug": 5179,
	"./view_snowflake_workbench.pug": 66813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77982;